module.exports = __webpack_public_path__ + "img/harry-styles-2024.0f2bfeda.jpg";